/**
 * Handle touch events on mobile
 */

const isTouchScreen = (() => {
    return 'ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch);
})();

export default (($) => {
    if (isTouchScreen) {
        const $nav = $('#primary-nav');
        const $children = $nav.children('.menu-item-has-children');

        // Prevent default action on first click
        $children.on('click', function clickHandler(event) {
            const $this = $(this);

            // Perform a reset - Remove the "clicked" class on all other menu items
            $children.not($this).removeClass('expanded');

            // Toggle "expanded" class
            $this.toggleClass('expanded');
            if ($this.hasClass('expanded')) {
                event.preventDefault();
            }
        });
    }
})(window.jQuery);
